/*
  SC Group Variants Dropdown
  - Fetches product variants from a fixed product JSON URL
  - Groups by the first option (option1)
  - Renders one <select> per type (option1)
  - On change, builds formData.items with { id, quantity } for all chosen dropdowns
  - Logs the chosen variant ID on change
*/
(function () {
  /**
   * Groups variants by option1.
   * @param {Array<any>} variants
   * @returns {Record<string, Array<{ id: number|string, options: string[] }>>}
   */
  function groupVariantsByFirstOption(variants) {
    return variants.reduce((acc, variant) => {
      const groupKey = variant.option1 || 'Default';
      if (!acc[groupKey]) acc[groupKey] = [];
      const options = [variant.option1, variant.option2, variant.option3].filter(Boolean);
      acc[groupKey].push({ id: variant.id, options });
      return acc;
    }, /** @type {Record<string, Array<{ id: number|string, options: string[] }>>} */ ({}));
  }

  /**
   * Creates and injects multiple dropdowns (one per option1 group) after the first <variant-picker>
   * (falls back to .product-details or body)
   * @param {Record<string, Array<{ id: number|string, options: string[] }>>} groups
   */
  function renderDropdowns(groups) {
    // Remove an existing container to avoid duplicates on reruns
    const existing = document.querySelector('.sc-group-variants-container');
    if (existing) existing.remove();

    const container = document.createElement('div');
    container.className = 'sc-group-variants-container';

    /**
     * Parses the first integer quantity from a label (e.g., "25 @ $4.20 each" -> 25).
     * @param {string} label
     * @returns {number}
     */
    function parseQuantityFromLabel(label) {
      const match = String(label).match(/(\d+)/);
      if (match && typeof match[1] === 'string') {
        const parsed = parseInt(match[1], 10);
        return Number.isFinite(parsed) ? parsed : 1;
      }
      return 1;
    }

    /**
     * Builds the formData object from current selections within this container.
     * @returns {{ items: Array<{ id: number, quantity: number }> }}
     */
    function buildFormDataFromSelections() {
      /** @type {Array<{ id: number, quantity: number }>} */
      const items = [];
      const selects = container.querySelectorAll('select');
      selects.forEach((select) => {
        if (!(select instanceof HTMLSelectElement)) return;
        const value = select.value;
        if (!value) return; // skip placeholders
        const selectedIndex = select.selectedIndex;
        const selectedOption = selectedIndex >= 0 ? select.options[selectedIndex] : null;
        const label = selectedOption && selectedOption.textContent ? selectedOption.textContent : '';
        const quantity = parseQuantityFromLabel(label || '');
        items.push({ id: Number(value), quantity });
      });
      /** @type {{ items: Array<{ id: number, quantity: number }> }} */
      const formData = { items };
      return formData;
    }

    /**
     * Returns the line item properties to send with each item.
     * Gets customization data from Webyze Live Preview Options.
     */
    function getCustomizationProperties() {
      try {
        // Try to get data from Webyze Live Preview Options
        const webyzeData = getWebyzeCustomizationData();
        if (webyzeData && Object.keys(webyzeData).length > 0) {
          
          return webyzeData;
        }
      } catch (error) {
        console.warn('Failed to get Webyze customization data:', error);
      }

      // Fallback to default static values
      const defaultData = {
        'CHOOSE YOUR FOIL COLOR': 'Silver Foil',
        'Product Preview':
          'https://cdn.shopify.com/s/files/1/0620/3824/5438/uploads/dc78ed8ae9d0ef2176a0bf2af066a43e.png',
        'Row 1': 'Thank you',
        'Row 1 (Text Align)': 'center',
        'Row 1 (Text Color)': '#000000',
        'Row 1 (Text Font)': 'Arial',
        'Row 1 (Text Opacity)': '100',
        'Row 1 (Text Size)': '40',
        'Row 1 (Text Transform)': 'normal',
        'Row 2': 'Milk chocolate bar',
        'Row 2 (Text Align)': 'center',
        'Row 2 (Text Color)': '#000000',
        'Row 2 (Text Font)': 'Arial',
        'Row 2 (Text Opacity)': '100',
        'Row 2 (Text Size)': '40',
        'Row 2 (Text Transform)': 'normal',
      };
      
      
      return defaultData;
    }

    /**
     * Gets customization properties from Webyze Live Preview Options system
     */
    function getWebyzeCustomizationData() {
      /** @type {Record<string, any>} */
      const properties = {};

      // Look for the main Webyze form container
      const webyzeForm = document.querySelector('.webyze-infinitelivepreviewoptions-form');
      if (!webyzeForm) {
        
        return properties;
      }

      

      // Extract all Webyze options by going through each option container
      webyzeForm.querySelectorAll('.webyze-ilpo-option').forEach((optionEl) => {
        if (!(optionEl instanceof HTMLElement)) return;
        
        const optionData = optionEl.dataset;
        const optionType = optionData.type;
        const localId = optionData.localId;
        
        if (!localId) return;

        const label = optionEl.querySelector('label');
        const fieldName = (label && label.textContent) ? label.textContent.trim().replace(/:\s*$/, '') : localId;

        switch (optionType) {
          case 'text': {
            /** @type {HTMLInputElement|HTMLTextAreaElement|null} */
            const textInput = optionEl.querySelector(`#webyze-ilpo-opt-${localId}`);
            if (textInput && 'value' in textInput && textInput.value) {
              properties[fieldName] = textInput.value;

              // Get font properties if they exist
              /** @type {HTMLInputElement|null} */
              const fontSizeEl = document.querySelector(`#webyze-ilpo-${localId}-font-size`);
              /** @type {HTMLInputElement|null} */
              const fontFamilyEl = document.querySelector(`#webyze-ilpo-${localId}-font-family_value`);
              /** @type {HTMLInputElement|null} */
              const fontColorEl = document.querySelector(`#webyze-ilpo-${localId}-font-color`);
              /** @type {HTMLInputElement|null} */
              const fontOpacityEl = document.querySelector(`#webyze-ilpo-${localId}-font-opacity`);
              /** @type {HTMLSelectElement|null} */
              const fontAlignEl = document.querySelector(`#webyze-ilpo-${localId}-font-align`);
              /** @type {HTMLSelectElement|null} */
              const fontTransformEl = document.querySelector(`#webyze-ilpo-${localId}-font-transform`);
              /** @type {HTMLInputElement|null} */
              const fontLineHeightEl = document.querySelector(`#webyze-ilpo-${localId}-font-line-height`);

              if (fontSizeEl && fontSizeEl.value) {
                properties[`${fieldName} (Text Size)`] = fontSizeEl.value;
              }
              if (fontFamilyEl && fontFamilyEl.value) {
                properties[`${fieldName} (Text Font)`] = fontFamilyEl.value;
              }
              if (fontColorEl && fontColorEl.value) {
                properties[`${fieldName} (Text Color)`] = fontColorEl.value;
              }
              if (fontOpacityEl && fontOpacityEl.value) {
                properties[`${fieldName} (Text Opacity)`] = fontOpacityEl.value;
              }
              if (fontAlignEl && fontAlignEl.value) {
                properties[`${fieldName} (Text Align)`] = fontAlignEl.value;
              }
              if (fontTransformEl && fontTransformEl.value) {
                properties[`${fieldName} (Text Transform)`] = fontTransformEl.value;
              }
              if (fontLineHeightEl && fontLineHeightEl.value) {
                properties[`${fieldName} (Line Height)`] = fontLineHeightEl.value + '%';
              }
            }
            break;
          }

          case 'color': {
            const currentSwatch = optionEl.querySelector('.webyze-ilpo-swatch.current');
            if (currentSwatch instanceof HTMLElement) {
              const swatchName = currentSwatch.dataset.swatchName || currentSwatch.title;
              properties[fieldName] = swatchName;
            }
            break;
          }

          case 'dropdown': {
            /** @type {HTMLSelectElement|null} */
            const selectEl = optionEl.querySelector(`#webyze-ilpo-opt-${localId}`);
            if (selectEl && selectEl.selectedIndex >= 0) {
              const selectedOption = selectEl.options[selectEl.selectedIndex];
              if (selectedOption) {
                properties[fieldName] = selectedOption.textContent || selectedOption.value;
              }
            }
            break;
          }

          case 'image': {
            const currentImage = optionEl.querySelector('.webyze-image-option.current');
            if (currentImage instanceof HTMLElement) {
              properties[fieldName] = currentImage.dataset.value;
            }
            break;
          }

          case 'checkbox': {
            /** @type {HTMLInputElement|null} */
            const checkboxEl = optionEl.querySelector(`#webyze-ilpo-opt-${localId}`);
            if (checkboxEl && 'checked' in checkboxEl) {
              properties[fieldName] = checkboxEl.checked ? 'Yes' : 'No';
            }
            break;
          }

          case 'upload': {
            // Handle file uploads - get file info for Shopify upload
            const webyzeInput = optionEl.querySelector(`#webyze-ilpo-opt-${localId}`);
            if (webyzeInput instanceof HTMLInputElement && webyzeInput.files && webyzeInput.files.length > 0) {
              const file = webyzeInput.files[0];
              if (file) {
                // Store file reference info - Shopify will handle the actual upload
                properties[fieldName] = `${file.name} (${Math.round(file.size / 1024)}KB)`;
              }
            }
            break;
          }
        }
      });

      // Check for product preview blob (stored globally by Webyze)
      /** @type {any} */
      const windowObj = window;
      if (windowObj.webyzeilpo_productPreviewPropName && windowObj.U) {
        properties[windowObj.webyzeilpo_productPreviewPropName || 'Product Preview'] = 'Preview generated';
      }

      
      return properties;
    }

    /**
     * Returns the Webyze preview canvas element if available.
     * @returns {HTMLCanvasElement|null}
     */
    function getWebyzePreviewCanvas() {
      const wrapper = document.querySelector('.webyze-ilpo-preview-wrapper');
      if (!wrapper) return null;
      const canvas = wrapper.querySelector('canvas');
      return canvas instanceof HTMLCanvasElement ? canvas : null;
    }

    /**
     * Resolves with a PNG Blob of the current Webyze preview, or null if not available.
     * @returns {Promise<Blob|null>}
     */
    function getWebyzePreviewBlob() {
      return new Promise((resolve) => {
        try {
          const canvas = getWebyzePreviewCanvas();
          if (!canvas) return resolve(null);
          if (canvas.toBlob) {
            canvas.toBlob((blob) => resolve(blob || null), 'image/png');
          } else {
            // Fallback via dataURL
            const dataUrl = canvas.toDataURL('image/png');
            const base64 = dataUrl.split(',')[1] || '';
            const binary = atob(base64);
            const len = binary.length;
            const bytes = new Uint8Array(len);
            for (let i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i);
            resolve(new Blob([bytes], { type: 'image/png' }));
          }
        } catch (e) {
          console.warn('SC Group Variants: Failed to get preview blob', e);
          resolve(null);
        }
      });
    }

    /**
     * Property name used by Webyze for the preview image.
     */
    function getPreviewPropName() {
      const win = /** @type {any} */ (window);
      return win.webyzeilpo_productPreviewPropName || 'Product Preview';
    }

    /**
     * Emits a DOM event when a preview URL is available in an item response.
     * @param {any} item
     */
    function emitPreviewUrlFromItem(item) {
      try {
        const propName = getPreviewPropName();
        const url = item && item.properties && item.properties[propName];
        if (typeof url === 'string' && /^https?:\/\//i.test(url)) {
          document.dispatchEvent(new CustomEvent('preview:url', { detail: { url, item } }));
        }
      } catch (e) {
        // no-op
      }
    }

    /**
     * Checks if there are any file uploads in the Webyze form.
     * @returns {Promise<boolean>}
     */
    async function checkForFileUploads() {
      const webyzeForm = document.querySelector('.webyze-infinitelivepreviewoptions-form');
      if (!webyzeForm) return false;

      const uploadOptions = webyzeForm.querySelectorAll('.webyze-ilpo-option[data-type="upload"]');
      for (const optionEl of uploadOptions) {
        if (!(optionEl instanceof HTMLElement)) continue;
        const localId = optionEl.dataset.localId;
        if (!localId) continue;
        
        const webyzeInput = optionEl.querySelector(`#webyze-ilpo-opt-${localId}`);
        if (webyzeInput instanceof HTMLInputElement && webyzeInput.files && webyzeInput.files.length > 0) {
          return true;
        }
      }
      return false;
    }

    /**
     * Attaches file uploads from Webyze form to FormData.
     * @param {FormData} formData
     */
    async function attachFileUploads(formData) {
      const webyzeForm = document.querySelector('.webyze-infinitelivepreviewoptions-form');
      if (!webyzeForm) return;

      const uploadOptions = webyzeForm.querySelectorAll('.webyze-ilpo-option[data-type="upload"]');
      for (const optionEl of uploadOptions) {
        if (!(optionEl instanceof HTMLElement)) continue;
        const localId = optionEl.dataset.localId;
        if (!localId) continue;

        const label = optionEl.querySelector('label');
        const fieldName = (label && label.textContent) ? label.textContent.trim().replace(/:\s*$/, '') : localId;
        
        const webyzeInput = optionEl.querySelector(`#webyze-ilpo-opt-${localId}`);
        if (webyzeInput instanceof HTMLInputElement && webyzeInput.files && webyzeInput.files.length > 0) {
          const file = webyzeInput.files[0];
          if (file) {
            // Use the same property name format that Webyze uses
            formData.append(`properties[${fieldName}]`, file, file.name);
          }
        }
      }
    }

    /**
     * Sends a single cart/add request with multiple items.
     * @param {Array<{ id: number, quantity: number }>} items
     */
    async function addAllToCart(items) {
      if (!items.length) return;
      
      // Get the customization properties from Webyze
      const customizationProperties = getCustomizationProperties();
      
      const cartAddUrl = (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
      
      // Check if we have any file uploads that need FormData
      const hasFileUploads = await checkForFileUploads();
      
      // Try to capture preview blob (if available)
      const previewBlob = await getWebyzePreviewBlob();
      const previewPropName = getPreviewPropName();
      
      if (previewBlob || hasFileUploads) {
        // When we have files (preview or uploads), we must use multipart/form-data.
        // Shopify does not support file properties in JSON payloads.
        // We will add items sequentially so each gets the file properties.
        /** @type {Array<any>} */
        const results = [];
        for (let idx = 0; idx < items.length; idx++) {
          const it = items[idx];
          if (!it) continue;
          const fd = new FormData();
          fd.append('id', String(it.id));
          fd.append('quantity', String(it.quantity));
          
          // Attach regular properties (non-file)
          Object.keys(/** @type {Record<string, any>} */(customizationProperties) || {}).forEach((key) => {
            const val = /** @type {Record<string, any>} */(customizationProperties)[key];
            if (val == null) return;
            // Avoid duplicating the preview as string; it will be attached as a file below
            if (String(key).trim() === String(previewPropName).trim()) return;
            fd.append(`properties[${key}]`, String(val));
          });
          
          // Attach preview as file if available
          if (previewBlob) {
            fd.append(`properties[${previewPropName}]`, previewBlob, 'productPreview.png');
          }
          
          // Attach any file uploads
          await attachFileUploads(fd);
          
          const resp = await fetch(cartAddUrl, {
            method: 'POST',
            body: fd,
            credentials: 'same-origin'
          });
          if (!resp.ok) throw new Error(`Add to cart failed: ${resp.status}`);
          const json = await resp.json();
          results.push(json);
          // Emit a single event for the first successful response (contains the CDN URL)
          if (idx === 0) emitPreviewUrlFromItem(json);
        }
        return results;
      } else {
        // No files, use JSON multi-item add
        const payload = {
          items: items.map((it) => ({
            id: it.id,
            quantity: it.quantity,
            properties: customizationProperties
          }))
        };
        const response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(payload),
          credentials: 'same-origin',
        });
        if (!response.ok) throw new Error(`Add to cart failed: ${response.status}`);
        const json = await response.json();
        // In case the backend adds the preview property, try to emit URL (best-effort)
        emitPreviewUrlFromItem(json);
        return json;
      }
    }

    // Create CTA button below the dropdowns
    const addButton = document.createElement('button');
    addButton.type = 'button';
    addButton.className = 'button';
    addButton.id = 'sc-group-variants-add-button';
    addButton.textContent = 'Add Selected to Cart';
    addButton.style.marginTop = '8px';
    addButton.disabled = true; // enabled when at least one selection

    // Create rush fee radio button group
    const rushFeeContainer = document.createElement('div');
    rushFeeContainer.style.marginTop = '12px';
    rushFeeContainer.style.display = 'none'; // Initially hidden
    rushFeeContainer.classList.add('sc-rush-fee-container');

    // Calculate dynamic date (10 business days from today)
    function calculateBusinessDays(startDate, days) {
      const result = new Date(startDate);
      let count = 0;
      while (count < days) {
        result.setDate(result.getDate() + 1);
        // Skip weekends (Saturday = 6, Sunday = 0)
        if (result.getDay() !== 0 && result.getDay() !== 6) {
          count++;
        }
      }
      return result;
    }

    const today = new Date();
    const standardDate = calculateBusinessDays(today, 10);
    const rushDate = calculateBusinessDays(today, 5);
    
    // Format dates
    const standardDateString = standardDate.toLocaleDateString('en-US', {
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
    const rushDateString = rushDate.toLocaleDateString('en-US', {
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });

    // Create description text with dynamic date
    const descriptionText = document.createElement('p');
    descriptionText.textContent = `The first available shipping or pickup date for custom bar wrappers is ${standardDateString}. If you need your order sooner (minimum 5 business days), please add a $50 rush fee.`;
    descriptionText.style.margin = '0 0 12px 0';
    descriptionText.style.fontSize = '14px';
    descriptionText.style.lineHeight = '1.4';

    // Create radio button group container
    const radioGroup = document.createElement('div');
    radioGroup.style.display = 'flex';
    radioGroup.style.flexDirection = 'column';
    radioGroup.style.gap = '8px';

    // Create Rush Order radio button
    const rushOption = document.createElement('div');
    rushOption.style.display = 'flex';
    rushOption.style.alignItems = 'center';
    rushOption.style.gap = '8px';

    const rushRadio = document.createElement('input');
    rushRadio.type = 'radio';
    rushRadio.name = 'shipping-option';
    rushRadio.id = 'sc-rush-order';
    rushRadio.value = 'rush';
    rushRadio.style.margin = '0';

    const rushLabel = document.createElement('label');
    rushLabel.setAttribute('for', 'sc-rush-order');
    rushLabel.textContent = `Rush My Order (${rushDateString}) +$50`;

    rushOption.appendChild(rushRadio);
    rushOption.appendChild(rushLabel);

    // Add event listener to hide error when rush option is selected
    rushRadio.addEventListener('change', () => {
      if (rushRadio.checked) {
        errorMessage.style.display = 'none';
      }
    });

    // Create Standard Order radio button
    const standardOption = document.createElement('div');
    standardOption.style.display = 'flex';
    standardOption.style.alignItems = 'center';
    standardOption.style.gap = '8px';

    const standardRadio = document.createElement('input');
    standardRadio.type = 'radio';
    standardRadio.name = 'shipping-option';
    standardRadio.id = 'sc-standard-order';
    standardRadio.value = 'standard';
    standardRadio.style.margin = '0';

    const standardLabel = document.createElement('label');
    standardLabel.setAttribute('for', 'sc-standard-order');
    standardLabel.textContent = `Standard Order Processing Time (${standardDateString})`;

    standardOption.appendChild(standardRadio);
    standardOption.appendChild(standardLabel);

    // Add event listener to hide error when standard option is selected
    standardRadio.addEventListener('change', () => {
      if (standardRadio.checked) {
        errorMessage.style.display = 'none';
      }
    });

    // Assemble the container
    radioGroup.appendChild(rushOption);
    radioGroup.appendChild(standardOption);
    rushFeeContainer.appendChild(descriptionText);
    rushFeeContainer.appendChild(radioGroup);

    // TEMPORARY DEBUG - Clear session storage
    function clearRushFeeSession() {
      sessionStorage.removeItem('rushFeeAdded');
    }
    
    // Call this to reset - you can remove this later
    clearRushFeeSession();

    // Check if rush fee has been added in this session (persistent across page navigations)
    function hasRushFeeBeenAdded() {
      return sessionStorage.getItem('rushFeeAdded') === 'true';
    }

    function markRushFeeAsAdded() {
      sessionStorage.setItem('rushFeeAdded', 'true');
    }

    // Initialize rush fee state on page load
    async function initializeRushFeeState() {
      try {
        const rushFeeInCart = await isRushFeeInCart();
        if (rushFeeInCart) {
          // Rush fee is already in cart, mark it as added in session
          markRushFeeAsAdded();
        }
      } catch (error) {
        console.warn('Failed to initialize rush fee state:', error);
      }
    }

    // Check if rush fee product is already in cart
    async function isRushFeeInCart() {
      try {
        const cartUrl = (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_url) || '/cart.js';
        const response = await fetch(cartUrl);
        if (!response.ok) return false;
        
        const cart = await response.json();
        if (!cart || !cart.items || !Array.isArray(cart.items)) return false;
        
        // Check if rush fee product (ID: 42025847226430) is already in cart
        const rushFeeExists = cart.items.some((/** @type {any} */ item) => item.variant_id === 42025847226430);
        return rushFeeExists;
      } catch (error) {
        console.warn('Failed to check cart for rush fee:', error);
        return false;
      }
    }

    function updateButtonState() {
      const { items } = buildFormDataFromSelections();
      addButton.disabled = items.length === 0;
      
      // Show/hide rush fee radio group based on button state and cart contents
      if (items.length > 0) {
        // Check if rush fee is already in cart before showing radio group
        isRushFeeInCart().then(rushFeeExists => {
          
          // Don't show radio group if rush fee is already in cart OR if we've added it in this session
          if (!rushFeeExists && !hasRushFeeBeenAdded()) {
            rushFeeContainer.style.display = 'block';
          } else {
            rushFeeContainer.style.display = 'none';
          }
        }).catch(error => {
          console.error('Error checking rush fee in cart:', error);
          // If cart check fails, show radio group anyway (fallback)
          if (!hasRushFeeBeenAdded()) {
            rushFeeContainer.style.display = 'block';
          }
        });
      } else {
        rushFeeContainer.style.display = 'none';
      }
    }

    Object.keys(groups).forEach((groupLabel, index) => {
      const block = document.createElement('div');
      block.className = 'sc-group-variants-block';
      block.style.marginBottom = '12px';

      const label = document.createElement('label');
      label.textContent = groupLabel;
      label.setAttribute('for', `sc-group-variants-select-${index}`);

      const select = document.createElement('select');
      select.id = `sc-group-variants-select-${index}`;
      select.style.marginTop = '8px';
      select.style.width = '100%';

      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = `Choose ${groupLabel}`;
      placeholder.disabled = false;
      placeholder.selected = true;
      select.appendChild(placeholder);

      const entries = groups[groupLabel] || [];
      entries.forEach((entry) => {
        const option = document.createElement('option');
        option.value = String(entry.id);
        const [option1, option2, option3] = entry.options;
        const display = option2 || [option1, option2, option3].filter(Boolean).join(' - ');
        option.textContent = display;
        select.appendChild(option);
      });

      select.addEventListener('change', (e) => {
        const target = e.target;
        if (!(target instanceof HTMLSelectElement)) return;
        const formData = buildFormDataFromSelections();
        
        updateButtonState();
      });

      block.appendChild(label);
      block.appendChild(select);
      container.appendChild(block);
    });

    addButton.addEventListener('click', async () => {
      try {
        const { items } = buildFormDataFromSelections();
        if (!items.length) return;
        
        // Check if rush fee container is visible and validate radio button selection
        if (rushFeeContainer.style.display !== 'none') {
          const selectedOption = document.querySelector('input[name="shipping-option"]:checked');
          if (!selectedOption) {
            errorMessage.style.display = 'block';
            return;
          } else {
            errorMessage.style.display = 'none';
          }
        } else {
          errorMessage.style.display = 'none';
        }
        
        addButton.disabled = true;
        addButton.textContent = 'Adding...';
        
        // Check if rush fee radio button is selected and add rush fee product FIRST
        // (so it appears below the main products in cart)
        if (rushRadio.checked) {
          try {
            const rushFeeFormData = {
              'items': [{
                'id': 42025847226430,
                'quantity': 1
              }]
            };

            const cartAddUrl = (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';

            await fetch(cartAddUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(rushFeeFormData)
            });
            // Reset radio button state
            rushRadio.checked = false;
            standardRadio.checked = false;
            
            // Update button state to hide radio group (since rush fee is now in cart)
            updateButtonState();
          } catch (rushFeeError) {
            console.error('Error adding rush fee:', rushFeeError);
          }
        }
        
        // Add the main items to cart AFTER rush fee
        const data = await addAllToCart(items);
        
        // Redirect to cart after successful add
        try {
          const root = (typeof window !== 'undefined' && /** @type {any} */ (window).Shopify && /** @type {any} */ (window).Shopify.routes && /** @type {any} */ (window).Shopify.routes.root) || '/';
          window.location.href = root + 'cart';
        } catch (_) {
          window.location.href = '/cart';
        }
      } catch (err) {
        console.error(err);
      } finally {
        addButton.textContent = 'Add Selected to Cart';
        addButton.disabled = false;
      }
    });

    // Create error message element
    const errorMessage = document.createElement('div');
    errorMessage.id = 'sc-shipping-error';
    errorMessage.style.color = 'red';
    errorMessage.style.fontSize = '14px';
    errorMessage.style.fontWeight = '600';
    errorMessage.style.marginTop = '8px';
    errorMessage.style.display = 'none';
    errorMessage.textContent = 'Please select a shipping option before adding to cart.';

    container.appendChild(addButton);
    container.appendChild(errorMessage);
    container.appendChild(rushFeeContainer);
    
    // Initialize rush fee state first
    initializeRushFeeState();
    
    // Initialize button state
    updateButtonState();

    // Insert into the page: prefer just before .buy-buttons-block
    const buyButtonsBlock = document.querySelector('.buy-buttons-block');
    const variantPicker = document.querySelector('variant-picker');

    if (buyButtonsBlock && buyButtonsBlock.parentElement) {
      
      buyButtonsBlock.parentElement.insertBefore(container, buyButtonsBlock);
    } else if (variantPicker && variantPicker.parentElement) {
      
      variantPicker.parentElement.insertBefore(container, variantPicker.nextSibling);
    } else {
      const productDetails = document.querySelector('.product-details');
      if (productDetails) {
        
        productDetails.appendChild(container);
      } else {
        
        document.body.appendChild(container);
      }
    }

    
  }
  // This is the main function that runs when the page loads
  function init() {
    document.body.classList.add('customised-product');
    try {
      const productJsonUrl = location.pathname + '.js';
      fetch(productJsonUrl)
        .then((r) => r.json())
        .then((product) => {
          
          if (!product || !Array.isArray(product.variants)) return;

          const groups = groupVariantsByFirstOption(product.variants);
          renderDropdowns(groups);
        })
        .catch((err) => {
          console.error('Failed to load product variants:', err);
        });
    } catch (e) {
      console.error(e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();